import { RefObject, useCallback, useEffect, useRef, useState } from 'react';

const ESC_KEY = 27;

const onEscapeKeyPress = fn => ({ keyCode }) => (keyCode === ESC_KEY ? fn() : null);

const useDropdown = (): [RefObject<HTMLDivElement>, boolean, () => void, () => void] => {
  const [dropdownOpen, setDropdownOpen] = useState<boolean>(false);
  const wrapperRef: RefObject<HTMLDivElement> = useRef(null);

  const toggleDropdown = useCallback(() => {
    setDropdownOpen(!dropdownOpen);
  }, [dropdownOpen]);

  const closeDropdown = useCallback(() => {
    setDropdownOpen(false);
  }, []);

  useEffect(() => {
    const handleGlobalMouseDown = ({ target }) => {
      if (!wrapperRef.current || wrapperRef.current.contains(target)) {
        return;
      }

      closeDropdown();
    };

    const handleGlobalKeydown = onEscapeKeyPress(closeDropdown);

    document.addEventListener('mousedown', handleGlobalMouseDown);
    document.addEventListener('keydown', handleGlobalKeydown);

    return () => {
      document.removeEventListener('mousedown', handleGlobalMouseDown);
      document.removeEventListener('keydown', handleGlobalKeydown);
    };
  }, [closeDropdown]);

  return [wrapperRef, dropdownOpen, toggleDropdown, closeDropdown];
};

export default useDropdown;
